import { FC, memo } from 'react';
import { Skeleton } from 'antd';
import Blocks from '../Blocks/Blocks';
import SiteMenu from '../SiteMenu/SiteMenu';
import { ClinicSettingsFilter } from './ClinicSettingsFilter/ClinicSettingsFilter';
import { ClinicSettingsTable } from './ClinicSettingsTable/ClinicSettingsTable';
import { useClinicSettings } from '../../hooks/components/useClinicSettings/useClinicSettings';
import styles from './styles.module.css';
import blockStyles from '../Blocks/style.module.css';
import { LoadingOverlay } from '../shared/Loading';

const SKELETON_CARD_COUNT = 6;

const ClinicListSkeleton: FC = () => (
  <div className={styles.skeletonList}>
    {Array.from({ length: SKELETON_CARD_COUNT }, (_, i) => (
      <div key={i} className={styles.skeletonCard}>
        <Skeleton.Avatar active shape="square" size={44} />
        <Skeleton
          active
          title={{ width: '40%' }}
          paragraph={{ rows: 1, width: ['60%'] }}
          className={styles.skeletonText}
        />
      </div>
    ))}
  </div>
);

export const SettingsCalls: FC = memo(() => {
  const props = useClinicSettings();

  return (
    <>
      <Blocks
        topBlock={
          <div className={blockStyles.topBlockRowStart}>
            <SiteMenu
              title="Настройки: Звонки"
              subtitle="Управление медицинскими организациями, графиками работы и параметрами звонков"
              svg={true}
              svgType="settingsCalls"
            />
          </div>
        }
        middleBlock={
          <div className={styles.middleBlock}>
            <div className={styles.sectionHeaderRow}>
              <div className={styles.sectionHeaderText}>
                <span className={styles.sectionTitle}>
                  Список медицинских организаций
                </span>
                <span className={styles.sectionSubtitle}>
                  Выберите медицинскую организацию для настройки параметров
                  звонков
                </span>
              </div>
              <ClinicSettingsFilter
                onSearch={props.handleSearch}
                value={props.searchInputValue}
                disabled={props.status.responseLoading}
              />
            </div>
          </div>
        }
        mainBlock={
          props.status.responseLoading && props.items.length === 0 ? (
            <ClinicListSkeleton />
          ) : (
            <LoadingOverlay spinning={props.status.responseLoading}>
              <ClinicSettingsTable
                items={props.items}
                totalItemsCount={props.totalItemsCount}
                callRequest={props.callRequest}
                pageSize={props.pageSize}
                onChange={props.handleChange}
                handlePageSizeChange={props.handlePageSizeChange}
                loading={props.status.responseLoading}
                hasLoadError={Boolean(props.status.responseError)}
              />
            </LoadingOverlay>
          )
        }
      />
    </>
  );
});

SettingsCalls.displayName = 'SettingsCalls';
